import * as Yup from 'yup';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useFormik, Form, FormikProvider } from 'formik';
// material
import * as CryptoJS from "crypto-js";
import { Alert, InputLabel, Stack, TextField } from '@material-ui/core';
import { LoadingButton } from '@material-ui/lab';

// ----------------------------------------------------------------------

export default function LoginForm() {
  const navigate = useNavigate();
  const [passwordError, setpasswordError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const LoginSchema = Yup.object().shape({
    email: Yup.string().email('Email must be a valid email address').required('Email is required')
  });

  const formik = useFormik({
    initialValues: {
      email: '',
      password: '',
      remember: true
    },
    validationSchema: LoginSchema,
    onSubmit: () => {
      const user = { email: values.email };
      const encuser ={
        "encryptedData": CryptoJS.AES.encrypt(JSON.stringify(user), '!hrv7PSJxkzTy#g!+=KzsbLcmU4fW4tgZEr_4WkR').toString()
      }
      console.log(user, 'user data to send');
      fetch(`${process.env.REACT_APP_BASEURL}/api/users/requestRequestPassword`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify(encuser)
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.data) {
            values.email = '';
            setSuccessMessage(true);
            setTimeout(() => {
              setSuccessMessage(false);
            }, 3000);
          } else {
            values.email = '';
            console.log(values.email);
            setpasswordError(data.msg);
          }
        });
    }
  });

  const { errors, touched, values, handleSubmit, getFieldProps } = formik;

  return (
    <FormikProvider value={formik}>
      <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
        <Stack spacing={3}>
          <InputLabel style={{color: 'rgb(199 199 199)', marginBottom: "-3%"}}>Email ID</InputLabel>
          <TextField
            fullWidth
            autoComplete="off"
            type="email"
            label=""
            name="email"
            {...getFieldProps('email')}
            error={Boolean(touched.email && errors.email)}
           // helperText={touched.email && errors.email}
            style={{backgroundColor: "#ffffff", borderRadius: "8px"}}
          />
          <LoadingButton fullWidth size="large" type="submit" variant="contained">
            Submit
          </LoadingButton>
          {successMessage ? (
            <Alert severity="success">
              Reset Password link was sent to your email seccussfully
            </Alert>
          ) : (
            ''
          )}
          {passwordError ? <Alert severity="success">{passwordError}</Alert> : ''}
        </Stack>
      </Form>
    </FormikProvider>
  );
}
